module.exports = __webpack_public_path__ + "static/media/clg.1d24d52a.png";